import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const PalletIcon: FC<Props> = (props) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="art icon">
      {/* <title>art icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1124 3.94339C15.6508 3.94923 18.2301 4.77527 19.8968 6.77469C21.542 8.74784 22.3924 11.9839 20.8289 14.2392C19.8345 15.6733 18.1532 16.3846 16.4642 16.5733C14.7946 16.7611 14.1943 17.8693 14.9298 19.5126C15.4708 20.723 14.9405 21.8049 13.4237 21.9197C7.90023 22.3371 3.20378 17.1649 3.99868 11.6725C4.6817 6.95177 8.30693 3.93172 13.1124 3.94339Z"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.98689 8.38392V8.43734M10.2033 8.3954C10.2033 8.51561 10.1058 8.61307 9.98555 8.61307C9.86534 8.61307 9.76794 8.51561 9.76794 8.3954C9.76794 8.27519 9.86534 8.17773 9.98555 8.17773C10.1058 8.17773 10.2033 8.27519 10.2033 8.3954Z"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6041 7.29212V7.34553M14.8205 7.3036C14.8205 7.42382 14.723 7.52127 14.6028 7.52127C14.4826 7.52127 14.3852 7.42382 14.3852 7.3036C14.3852 7.18339 14.4826 7.08594 14.6028 7.08594C14.723 7.08594 14.8205 7.18339 14.8205 7.3036Z"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1256 10.9191V10.9725M18.342 10.9306C18.342 11.0508 18.2445 11.1482 18.1243 11.1482C18.004 11.1482 17.9066 11.0508 17.9066 10.9306C17.9066 10.8103 18.004 10.7129 18.1243 10.7129C18.2445 10.7129 18.342 10.8103 18.342 10.9306Z"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44196 12.4874V12.5408M7.65837 12.4989C7.65837 12.6191 7.56084 12.7166 7.44063 12.7166C7.32042 12.7166 7.22302 12.6191 7.22302 12.4989C7.22302 12.3787 7.32042 12.2812 7.44063 12.2812C7.56084 12.2812 7.65837 12.3787 7.65837 12.4989Z"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PalletIcon;
